module.exports = __webpack_public_path__ + "media/images/b2b_admin/routing_requests_mini_screen-1f1ab4b6934ae525afae8a987b488ee8.png";